/**
 * PHOTO CAPTURE COMPONENT
 * 
 * Camera capture and file upload for photos
 */

import React, { useRef } from 'react';
import { Camera, Upload } from 'lucide-react';

const PhotoCapture = ({ onCapture, onUpload, disabled = false }) => {
  const fileInputRef = useRef(null);
  const cameraInputRef = useRef(null);

  const handleFileUpload = (e) => {
    const files = Array.from(e.target.files);
    if (files.length > 0) {
      onUpload(files);
    }
    e.target.value = ''; // Reset for next upload
  };

  const handleCameraCapture = (e) => {
    const files = Array.from(e.target.files);
    if (files.length > 0) {
      onCapture(files[0]);
    }
    e.target.value = '';
  };

  return (
    <div className="flex gap-3">
      {/* Camera Capture */}
      <button
        onClick={() => cameraInputRef.current?.click()}
        disabled={disabled}
        className="flex items-center gap-2 px-4 py-2 bg-emerald-600 hover:bg-emerald-500 
          text-white font-medium rounded disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <Camera className="w-5 h-5" />
        Capture Photo
      </button>
      <input
        ref={cameraInputRef}
        type="file"
        accept="image/*"
        capture="environment"
        onChange={handleCameraCapture}
        className="hidden"
      />
      
      {/* File Upload */}
      <button
        onClick={() => fileInputRef.current?.click()}
        disabled={disabled}
        className="flex items-center gap-2 px-4 py-2 bg-slate-700 hover:bg-slate-600 
          text-slate-200 font-medium rounded disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <Upload className="w-5 h-5" />
        Upload Photos
      </button>
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        multiple
        onChange={handleFileUpload}
        className="hidden"
      />
    </div>
  );
};

export default PhotoCapture;
